import * as React from "react";
import { useState } from "react";
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import SaveIcon from "@mui/icons-material/Save";

import { Link } from "gatsby";
import Layout from "../Layout";
import { RMPList } from "../db/RMP.json";
import { kanaToHira } from "../convertText";

function TableRows(props) {
  const { drugs, setDrugs } = props;

  if (drugs) {
    drugs.sort((a, b) => a.label.localeCompare(b.label), "ja");

    const pressDelete = (index) => {
      const copyDrugs = [...drugs];
      copyDrugs.splice(index, 1);
      console.log(copyDrugs);
      setDrugs(copyDrugs);
    };
    const rows = drugs.map((drug, index) => {
      return (
        <Grid>
          <Grid container>
            <Grid
              item
              md={3}
              xs={12}
              size={{ xs: 12, md: 3 }}
              style={TableRowCellStyle}
            >
              {drug.label}
            </Grid>
            <Grid
              item
              md={1}
              xs={6}
              size={{ xs: 6, md: 1 }}
              style={TableRowCellStyle}
            >
              {drug.yj_code}
            </Grid>
            <Grid
              item
              md={3}
              xs={6}
              size={{ xs: 6, md: 3 }}
              style={TableRowCellStyle}
            >
              {drug.company}
            </Grid>
            <Grid
              item
              md={1}
              xs={6}
              size={{ xs: 6, md: 1 }}
              style={TableRowCellStyle}
            >
              <Link to={drug.rmp_URL} target="_blank">
                RMP
              </Link>
            </Grid>
            <Grid
              item
              md={2}
              xs={6}
              size={{ xs: 6, md: 2 }}
              style={TableRowCellStyle}
            >
              {drug.date_of_submission}
            </Grid>
            <Grid
              item
              md={1}
              xs={6}
              size={{ xs: 6, md: 1 }}
              style={TableRowCellStyle}
            >
              <Link to={drug.pmda_URL} target="_blank">
                PMDA関連文書
              </Link>
            </Grid>
            <Grid
              item
              md={1}
              xs={6}
              size={{ xs: 6, md: 1 }}
              style={TableRowCellStyle}
            >
              <IconButton aria-label="delete">
                <DeleteIcon onClick={() => pressDelete(index)} />
              </IconButton>
            </Grid>
          </Grid>
          <Divider />
        </Grid>
      );
    });
    return rows;
  } else {
    return null;
  }
}

export default function RMPPage() {
  let savedDrugs;
  if (typeof window !== "undefined") {
    savedDrugs = JSON.parse(localStorage.getItem("drugs"));
  }

  const [drugs, setDrugs] = useState(savedDrugs !== null ? savedDrugs : []);

  const downloadCSV = () => {
    const filename = "RMP_List.csv";
    let downloadData =
      "薬品名,YJコード,製薬会社,RMP_URL,提出年月,PMDA関連文書_URL\n";

    drugs.forEach((drug) => {
      downloadData +=
        drug.label +
        "," +
        drug.yj_code +
        "," +
        drug.company +
        "," +
        drug.rmp_URL +
        " ," +
        drug.date_of_submission +
        "," +
        drug.pmda_URL +
        "\n";
    });
    console.log(downloadData);
    // // //BOMを付与
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);

    // //BlobからオブジェクトURLを作成
    const blob = new Blob([bom, downloadData], { type: "text/csv" });

    // //リンク先にダウンロード用リンクを指定する
    const link = document.createElement("a");
    link.download = filename;
    link.href = URL.createObjectURL(blob);
    link.click();

    // //createObjectURLで作成したオブジェクトURLを開放する
    URL.revokeObjectURL(link.href);
  };

  const saveLocalStorage = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("drugs", JSON.stringify(drugs));
    }
    alert("RMPリストを保存しました。");
  };

  const filterOptions = (options, { inputValue }) => {
    const inputHiragana = kanaToHira(inputValue); // 入力をひらがなに変換
    return options.filter((option) => {
      const optionHiragana = kanaToHira(option.label); // オプションラベルをひらがなに変換
      return (
        option.label.includes(inputValue) ||
        optionHiragana.includes(inputHiragana)
      );
    });
  };

  const contents = () => {
    const date = new Date().getTime();
    return (
      <Grid container rowSpacing={2}>
        <Grid size={{ xs: 12 }}>
          <title>患者向けRMP資材検索</title>
          <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
            患者向けRMP資材検索
          </Typography>
          <Grid>※ 患者向けRMP資材のある医薬品のみ検索できます</Grid>
          <Link href="https://www.cc-camp.com/rmp-search-tool/">
            RMP資材検索ツールの使い方
          </Link>
          <Grid>
            当ツールに関するお問い合わせやバグの報告などは
            <Link href="https://www.cc-camp.com/contact/">コチラ</Link>
            からどうぞ
          </Grid>
        </Grid>

        <Grid item container spacing={2} sx={{ width: "100%" }}>
          <Grid item md={5} xs={12} size={{ xs: 12, md: 5 }}>
            <Autocomplete
              disablePortal
              onChange={(event, newValue) => {
                const newDrugs = [...drugs];

                if (newValue) {
                  newValue.input_time = date;
                  newDrugs.push(newValue);
                  setDrugs(newDrugs);
                }
              }}
              id="combo-box-demo"
              getOptionLabel={(option) => option.label}
              filterOptions={filterOptions}
              options={RMPList}
              renderInput={(params) => <TextField {...params} label="薬品名" />}
            />
          </Grid>
          <Grid item md={2} xs={6} size={{ xs: 6, md: 2 }}>
            <Button variant="contained" onClick={() => downloadCSV()}>
              <DownloadIcon /> .csvダウンロード
            </Button>
          </Grid>
          <Grid item md={2} xs={6} size={{ xs: 6, md: 2 }}>
            <Button variant="contained" onClick={() => saveLocalStorage()}>
              <SaveIcon /> ブラウザに保存
            </Button>
          </Grid>
          <Grid item md={2} xs={12} size={{ xs: 12, md: 2 }}>
            <Button variant="outlined" onClick={() => setDrugs([])}>
              クリア
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12} size={{ xs: 12 }}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <Grid container>
                  <Grid
                    item
                    md={3}
                    xs={12}
                    size={{ xs: 12, md: 3 }}
                    style={HeaderTableStyle}
                  >
                    薬品名
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={6}
                    size={{ xs: 6, md: 1 }}
                    style={HeaderTableStyle}
                  >
                    YJコード
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={6}
                    size={{ xs: 6, md: 3 }}
                    style={HeaderTableStyle}
                  >
                    製薬会社
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={6}
                    size={{ xs: 6, md: 1 }}
                    style={HeaderTableStyle}
                  >
                    医薬品リスク管理計画書
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={6}
                    size={{ xs: 6, md: 2 }}
                    style={HeaderTableStyle}
                  >
                    提出年月
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={6}
                    size={{ xs: 6, md: 1 }}
                    style={HeaderTableStyle}
                  >
                    PMDA関連文書
                  </Grid>
                  <Grid
                    item
                    md={1}
                    xs={6}
                    size={{ xs: 6, md: 1 }}
                    style={HeaderTableStyle}
                  ></Grid>
                </Grid>
              </TableHead>
              <TableBody>
                <TableRows drugs={drugs} setDrugs={setDrugs} />
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid style={{ marginTop: 20, marginBottom: 20 }}>
          使用しているデータベースは
          <Link href="https://www.pmda.go.jp/safety/info-services/drugs/items-information/rmp/0001.html">
            PMDA　RMP提出品目一覧
          </Link>
          を参考に作成されています。
        </Grid>
      </Grid>
    );
  };
  return <Layout contents={contents()} />;
}

const HeaderTableStyle = {
  backgroundColor: "#1976d2",
  color: "#ffffff",
  textAlign: "center",
  padding: 20,
};
const TableRowCellStyle = {
  textAlign: "center",
  marginTop: 10,
  marginBottom: 10,
};
